import {
  Table,
  Input,
  Modal,
  Button,
  success,
  useState,
  useToggle,
  useEffect,
  updateList,
  ErrorAlert,
  Breadcrumb,
  SwitchInput,
  modalHandler,
  useFetchData,
  ModalOpenBtn,
  PageHero,
  DownloadExcel,
  useCustomForm,
  useTableColumns,
  useDebouncedSearch,
  TableRowsPerPage,
  ChatBubbleLeftRightIcon,
} from "@";
import { excelHeaderCellsName } from "./utils/options";
import { defaultValues, schema } from "./utils/validation";
import DrabbleConstantWords from "./components/DrabbleConstantWords";
import { TableActions, tableColumns } from "./components/TableOptions";
import {
  getGoals,
  getMessages,
  saveMessage,
  toggleActive,
  getConstants,
} from "./utils/api";

const Index = () => {
  const [search, setSearch] = useState("");
  const [goals, setGoals] = useState([]);
  const [constants, setConstants] = useState([]);
  const [isShow, setIsShow] = useState(false);

  // Breadcrumb links
  const links = [
    { name: "الاعدادات", link: "/all-settings" },
    { name: "التحكم في الرسائل ", link: "" },
  ];

  // Form setup
  const {
    reset,
    watch,
    errors,
    setValue,
    register,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(defaultValues, schema);

  // Fetch data
  const { data, isLoading, setData, error, pg, fetchData, updatePg } =
    useFetchData({
      fun: getMessages,
      params: [search],
    });

  useDebouncedSearch(fetchData, search);

  // Toggle active state
  const { active } = useToggle(setData, toggleActive);

  // Table columns setup
  const columns = useTableColumns(
    tableColumns,
    (row) => (
      <TableActions
        row={row}
        toggleActive={active}
        handlerEdit={handlerEdit}
        handlerShow={handlerShow}
      />
    ),
    1,
  );

  // Form submit handler
  const submit = async (form) => {
    try {
      await saveMessage(form);
      setData(updateList(data, form));
      success("تم الحفظ بنجاح");
      modalHandler();
      reset();
    } catch (error) {}
  };

  // Function to handle editing of carousel items
  const handlerEdit = (item) => {
    reset(item);
    modalHandler();
    setIsShow(false);
  };

  // Function to handle showing of message items
  const handlerShow = (item) => {
    setIsShow(true);
    reset(item);
    modalHandler();
  };

  // Fetch Constants based on the selected goal
  useEffect(() => {
    if (!watch("key")) {
      return;
    }
    const fetchConstants = async () => {
      const res = await getConstants(watch("key"));
      setConstants(res);
    };
    fetchConstants();
  }, [watch("key")]);

  // Fetch Goals
  useEffect(() => {
    const fetchGoals = async () => {
      const res = await getGoals();
      setGoals(res);
    };
    fetchGoals();
  }, []);

  return (
    <>
      {/* Error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      {/* Modal for editing user */}
      <ModalOpenBtn hidden />
      <Modal close={() => {}} title={isShow ? "عرض الرسالة" : "تعديل الرسالة"}>
        <form onSubmit={handleSubmit(submit)} className="p-4">
          <Input
            style="mb-5"
            label="العنوان"
            disabled={isShow}
            error={errors.title}
            input={register("title")}
          />

          <Input
            style="mb-5"
            type="select"
            disabled
            label="المفتاح"
            error={errors.key}
            value={watch("key")}
            list={goals}
          />

          <DrabbleConstantWords
            isShow={isShow}
            error={errors.body}
            setValue={setValue}
            input={register("body")}
            constants={constants}
          />

          <SwitchInput
            label="نشط"
            className="md:col-span-2"
            disabled={isShow}
            checked={watch("isActive")}
            change={(value) => setValue("isActive", value)}
            isBordered={true}
          />

          {!isShow && (
            <Button
              type="submit"
              className="mt-5"
              title="حفظ البيانات"
              isLoading={isSubmitting}
            />
          )}
        </form>
      </Modal>

      <main className="table-card relative">
        <PageHero
          eyebrow="الإعدادات / الرسائل"
          title="التحكم في الرسائل "
          count={pg.rows}
          icon={ChatBubbleLeftRightIcon}
          hideCount={isLoading}
        >
          <input
            className="single-search-input"
            onChange={(e) => setSearch(e.target.value)}
            placeholder="بحث"
            value={search}
            type="search"
          />

          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size: size })}
          />

          <DownloadExcel
            pageSize=""
            search={search}
            fetch={getMessages}
            length={data?.length}
            headerCellsName={excelHeaderCellsName}
          />
        </PageHero>

        {/* Table */}
        <Table
          data={data}
          pagination={pg}
          columns={columns}
          isLoading={isLoading}
          pageChange={(page) => updatePg({ page: page })}
          perRowsChange={(size) => updatePg({ size: size })}
        />
      </main>
    </>
  );
};

export default Index;
